import axios from 'axios';

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // A failed login also returns 401 (bad password, unconfirmed, awaiting approval);
    // let the login page show that message instead of reloading it.
    const isLoginAttempt = (error.config?.url || '').includes('/users/sign_in');
    // Handle 302 redirects as authentication failures (Devise redirects on auth failure)
    if (!isLoginAttempt && error.response && (error.response.status === 302 || error.response.status === 401)) {
      localStorage.removeItem('auth_token');
      window.location.href = "login";
    }
    // Handle network errors or cases where response might be undefined
    if (!error.response && error.message) {
      // Could be a network error or CORS issue
      console.error('Network error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axios;